import { Modal, ModalBody, Pre } from '@ijoin/components';
import { useGetAdminSsoError, type SsoErrorRowRes } from '@ijoin/hooks';
import { Typography } from '@mui/material';

import { humanizeErrorType } from './ssoErrors.utils';

export const SsoErrorDetailsModal = (props: {
  onClose: () => void;
  ssoError: null | SsoErrorRowRes;
}) => {
  const details = useGetAdminSsoError(props.ssoError?.ssoErrorId ?? '', {
    query: { enabled: !!props.ssoError }
  });

  return (
    <Modal
      data-testid='ssoErrorDetails'
      hasCloseBtn
      header={props.ssoError ? humanizeErrorType(props.ssoError.errorType) : ''}
      isOpen={!!props.ssoError}
      mdWidth={720}
      onClose={props.onClose}>
      <ModalBody isError={details.isError} isLoading={details.isFetching}>
        <Typography variant='overline'>Metadata</Typography>
        <Pre>
          {details.data?.meta
            ? JSON.stringify(details.data.meta, null, 2)
            : 'No metadata'}
        </Pre>
      </ModalBody>
    </Modal>
  );
};
